/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CreditCategoryStat {
  category: string;
  label: string;
  credits: number;
  entry_count: number;
  share: number;
}
